const Approvals = () => import("../exemption/views/Approvals.vue");
const EditExemption = () => import("../exemption/views/EditExemption.vue");
const ExemptionApprovalForm = () =>
  import("../exemption/views/ExemptionApprovalForm.vue");
const MyExemptions = () => import("../exemption/views/MyExemptions.vue");

export default [
  {
    path: "approvals",
    component: Approvals,
  },
  {
    path: "create",
    component: ExemptionApprovalForm,
  },
  {
    name: "edit-exemption",
    path: "edit/:id",
    component: EditExemption,
  },
  {
    path: "my-exemptions",
    component: MyExemptions,
  },
];
